import React, { Component, useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { Container, Row, Col, Table, Image, Spinner, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Form, Group, Label, Control, FormSelect } from 'react-bootstrap';

import "./MultiQuickpunch.css";
import { Formik, FieldArray, Field, ErrorMessage, getIn } from 'formik';
import moment from 'moment';
import { connect } from 'react-redux';
import { biometrixLogMulti, fetchProjectTaskData } from '../../../../store/actions/dtr/quickpunchActions'
import * as Yup from 'yup';
import Dropdown from 'react-bootstrap/Dropdown';
// import { getRecentDtr } from '../../../../store/actions/dashboard/dashboardActions';

class MultiQuickpunch extends Component {
	constructor(props) {


		super(props);
		this.timer = 0;
		this.state = {
			time: Date.now(),
			offsetHasLoaded: false,
			showModal: false,
			project_name: '',
			remarks: '',
			temp_values_formdata: '',
			modal_warn: false,
			project_id: '',
			task_id: '',
			isSubmitting: false,
		};
	}

	onSubmitHandler = async (values) => {
		if (this.state.isSubmitting) {
			return;
		}

		this.setState({ isSubmitting: true });

		// Setting of Form Data to be passed in the submission
		var formData = new FormData();

		if (values.quickpunch === 'pause' || values.quickpunch === 'out') {
			try {
				// call API to get projects and tasks list
				const response = await this.props.fetchProjectTaskData();
				console.log(48, response.projects, response.tasks_data);
				if (response.projects && response.tasks_data) {
					this.setState({
						temp_values_formdata: values,
						projects: response.projects,
						taskCategories: response.tasks_data,
						showModal: true
					});
				} else {
					alert('Failed to load project/task data');
				}

			} catch (error) {
				alert('Failed to load project/task data');
			} finally {
				this.setState({
					isSubmitting: false
				});
			}

			return; // stop further execution
		} else {
			for (var key in values) {
				if (values[key] != null) {
					switch (key) {
						default:
							formData.set(key, values[key]);
							break;
					}
				}
			}
			try {
				if (values['on_date'] == true) {
					if (window.confirm("Are you sure you want Update or create record on seleceted date")) {
						await this.props.biometrixLogMulti(formData, this.props.user.id);
					}
				} else {
					await this.props.biometrixLogMulti(formData, this.props.user.id);
				}
			} finally {
				this.setState({
					isSubmitting: false
				});
			}
			
		}
	}

	addSeconds(date, seconds) {
		date.setSeconds(date.getSeconds() + seconds);
		return date;
	}


	////////////////////////////////////////////////////////  ////////////////////////////////////////////////////////  ////////////////////////////////////////////////////////

	handleModalSubmit = async () => {
		if (this.state.isSubmitting) {
			return;
		}

		this.setState({ isSubmitting: true });
		
		const values = this.state.temp_values_formdata;

		const hasProjects = this.state.projects && this.state.projects.length > 0;
		const hasTasks = this.state.taskCategories && Object.values(this.state.taskCategories).some((tasks) => tasks && tasks.length > 0);

		const schema = Yup.object().shape({
			project_id: hasProjects
				? Yup.string().required("Project is required")
				: Yup.string().nullable(),

			task_id: hasTasks
				? Yup.string().required("Task is required")
				: Yup.string().nullable(),

			remarks: Yup.string().nullable()
		});

		try {
			await schema.validate(
				{
					project_id: this.state.project_id,
					task_id: this.state.task_id,
					remarks: this.state.remarks
				},
				{ abortEarly: false }
			);

			// clear validation state
			this.setState({
				modal_warn: false,
				validationErrors: {}
			});

			var formData = new FormData();

			for (var key in values) {
				if (values[key] != null) {
					switch (key) {
						default:
							formData.set(key, values[key]);
							break;
					}
				}
			}

			formData.set("remarks", this.state.remarks);
			formData.set("project_id", this.state.project_id);
			formData.set("task_id", this.state.task_id);
			
			try {
				if (values['on_date'] == true) {
					if (window.confirm("Are you sure you want Update or create record on seleceted date")) {
						await this.props.biometrixLogMulti(formData, this.props.user.id);
					}
				} else {
					await this.props.biometrixLogMulti(formData, this.props.user.id);
				}
			} finally {
				this.setState({
					isSubmitting: false
				});
			}

			this.handleModalClose();

		} catch (err) {
			const validationErrors = {};

			err.inner.forEach((error) => {
				validationErrors[error.path] = error.message;
			});

			this.setState({
				modal_warn: true,
				validationErrors
			});
		}
	};

	handleModalClose = () => {
		this.setState({
			showModal: false,

			project_id: "",
			task_id: "",
			remarks: "",

			modal_warn: false,
			validationErrors: {}
		});
	};

	handleRemarkChange = (value) => {
		this.setState({ remarks: value });
	};

	handleProjectChange = (value) => {
		this.setState({ project_id: value });
	};

	handleTaskChange = (value) => {
		this.setState({ task_id: value });
	};

	//////////////////////////////////////////////////////// ////////////////////////////////////////////////////////  ////////////////////////////////////////////////////////

	componentDidMount = async () => {
		this.clientStartTs = performance.now();

		this.timer = setInterval(() => {

			if (localStorage.getItem("access_token") == null) return;

			const clock = window.__SERVER_CLOCK__;

			if (!clock) return;

			const nowMils = clock.baseTimestamp + (performance.now() - clock.startPerf);

			this.setState({
				time: nowMils
			});
		}, 1000);
	}

	componentWillUnmount() {
		clearInterval(this.timer);
	}

	render = () => {
		const { recent_punch, isRecentPunchLoaded } = this.props.dashboard;
		const disablePunchButtons = this.state.isSubmitting;
		var isLogIn = false;
		var isContinue = false;
		var islogOut = false;
		var latest = null;
		var use_previous = false;
		var disable_day = false;
		var prev_disable_day = false;
		var rest_day_disabled = false;

		if (isRecentPunchLoaded == true) {



			if (recent_punch.length > 0) {

				latest = recent_punch[recent_punch.length - 1];

				if (latest.recent_log == "Pause") {
					isContinue = true;
				}

				if (latest.recent_log == "Log_out") {
					isLogIn = true;

				}

				if (latest.recent_log == "Log_in" || latest.recent_log == "Continue") {
					islogOut = true;
				}

			}

			if (recent_punch.length > 0) {

				latest = recent_punch[recent_punch.length - 1];
				if (latest.completed_today == true) {
					var date_time_out = new Date(latest.date_time_out);
					var formatted = moment(date_time_out);
					var last_timeout_date = formatted.format("Y-MM-DD");
					var current_date = moment.utc(this.state.time).format("Y-MM-DD");
					if (last_timeout_date == current_date && latest.date == current_date) {

						disable_day = true;
						if (latest.log_in_type == "rest_day_work" && !(moment.utc(this.state.time).isBetween(moment(new Date(latest.date_time_in)).startOf('day'), moment(new Date(latest.date_time_out)).add(1, 'hours')))) {
							disable_day = false;
						}
					}
				}
				if (latest.time_out != null && latest.recent_log == "Log_out" && latest.log_in_type == "rest_day_work") {
					if (moment.utc(this.state.time).isBetween(moment(new Date(latest.date_time_in)).startOf('day'), moment(new Date(latest.date_time_in)).add(1, 'hours'))) {
						disable_day = true;
					}
				}

				if (latest.completed_today == true) {
					if (formatted.format("Y-MM-DD") == moment.utc(this.state.time).subtract(1, "day").format("Y-MM-DD")) {
						prev_disable_day = true;
					}
				}
				if (latest.recent_log == "Log_out" && latest.date != moment.utc(this.state.time).format("Y-MM-DD")) {
					// isLogIn = true;

					if (moment.utc(this.state.time).isBetween(moment.utc(this.state.time).startOf('day'), moment.utc(this.state.time).startOf('day').add(5, 'hours'))) {

						use_previous = true;
						if (latest.time_out != null && latest.recent_log == "Log_out") {
							var time = new Date(latest.date_time_out);
							var formatted = moment(time);
							if (formatted.isBetween(moment.utc(this.state.time).startOf('day'), moment.utc(this.state.time).startOf('day').add(3, 'hours'))) {
								use_previous = false;
							}

							if (latest.time_out != null && latest.recent_log == "Log_out" && latest.log_in_type == "rest_day_work") {
								if (moment.utc(this.state.time).isBetween(moment.utc(this.state.time).startOf('day'), moment(new Date(latest.date_time_out)))) {
									use_previous = false;
								}
							}
						}
					}
				}

			}


			if (recent_punch.length == 0) {
				isLogIn = true;
				if (moment.utc(this.state.time).isBetween(moment.utc(this.state.time).startOf('day'), moment.utc(this.state.time).startOf('day').add(3, 'hours'))) {

					use_previous = true;

				}
			}



		}



		const initialValue = {
			quickpunch: null,
			date: "today",
			on_date: use_previous,
		}


		return (
			<div>
				<Formik
					enableReinitialize
					onSubmit={this.onSubmitHandler}
					validationSchema={validationSchema}
					initialValues={initialValue}>
					{
						({ values, errors, setFieldValue, field, touched, handleSubmit, handleReset, handleChange }) => (
							<form onSubmit={handleSubmit}>
								<div className="card">
									<div className="card-body quickpunch">
										<h3>QUICK PUNCH</h3>
										<Row>
											<Col className="date" >{moment.utc(this.state.time).format("dddd, MMMM Do")}</Col>
										</Row>
										<Row className="time">
											<Col>{moment.utc(this.state.time).format("HH")}</Col>
											<Col>{moment.utc(this.state.time).format("mm")}</Col>
											<Col>{moment.utc(this.state.time).format("ss")}</Col>
										</Row>
										<Row className="label">
											<Col>Hours</Col>
											<Col>Minutes</Col>
											<Col>Seconds </Col>
										</Row>
										{
											isRecentPunchLoaded == true ?

												<>
													{!use_previous ?
														<>
															<Button type="submit" disabled={disablePunchButtons || !isLogIn || disable_day} onClick={(e) => { setFieldValue('quickpunch', 'in'); }} ><i className="fa fa-clock-o" /> Clock In</Button>
														</>

														: <>

															<label className=" select-date-multi">Select Date:
																<select className="form-control-sm" style={{ display: 'block' }} onChange={(e) => { setFieldValue('date', e.target.value); }}>
																	{/* <option value="" label="" /> */}
																	<option value="today" label={moment().format("Y-MM-DD")} onClick={(e) => { setFieldValue('date', "today"); }} />
																	<option value="yesterday" disabled={prev_disable_day} label={moment().subtract(1, 'day').format("Y-MM-DD")} onClick={(e) => { setFieldValue('date', "yesterday"); }} />
																</select>
															</label>

															<br />
															<Button type="submit" disabled={disablePunchButtons || !isLogIn} onClick={(e) => { setFieldValue('quickpunch', 'in'); }} ><i className="fa fa-clock-o" /> Clock In</Button>

														</>}


													{!isLogIn ?
														<>
															{isContinue ?
																<Button disabled={disablePunchButtons} onClick={(e) => { setFieldValue('quickpunch', 'continue'); }} type="submit" ><i className="fa fa-play" /> Continue</Button> :
																<Button disabled={disablePunchButtons} onClick={(e) => { setFieldValue('quickpunch', 'pause'); }} type="submit" ><i className="fa fa-pause" /> Pause</Button>

															}
														</>

														: <></>}


													<Button disabled={disablePunchButtons || !islogOut} onClick={(e) => { setFieldValue('quickpunch', 'out'); }} type="submit"  ><i className="fa fa-history" /> Clock Out</Button>
												</> : <></>
										}



									</div>
								</div>
							</form>
						)}

				</Formik>

				<ConfirmSubmissionModal
					show={this.state.showModal}
					onHide={this.handleModalClose}
					remarks={this.state.remarks}
					onRemarkChange={this.handleRemarkChange}
					onProjectChange={this.handleProjectChange}
					onTaskChange={this.handleTaskChange}
					onSubmit={this.handleModalSubmit}
					modal_warn={this.state.modal_warn}
					projects={this.state.projects}
					taskCategories={this.state.taskCategories}
					validationErrors={this.state.validationErrors}
					project_id={this.state.project_id}
					task_id={this.state.task_id}
				/>
			</div>

		);
	}
}




const ConfirmSubmissionModal = ({
	show,
	onHide,
	remarks,
	onRemarkChange,
	onProjectChange,
	onTaskChange,
	onSubmit,
	modal_warn,
	projects,
	taskCategories,
	validationErrors,
	project_id,
	task_id
}) => (
	<Modal className="remark-modal" show={show} onHide={onHide} size="lg">
		<Modal.Header id="mc-modal-header" closeButton>
			<Modal.Title id="mc-modal-title">Confirm Submission</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<p>Are you sure you want to submit this?</p>
			<Form>
				{projects && projects.length > 0 && (
					<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
						<Form.Label>Project Name</Form.Label>
						<Form.Control as="select" required value={project_id} onChange={(e) => onProjectChange(e.target.value)}>
							<option value="">Select Project</option>

							{projects && projects.map((project, index) => (
								<option key={index} value={project.id}>
									{project.name}
								</option>
							))}
						</Form.Control >
						{validationErrors?.project_id && (
							<div className="text-danger">
								{validationErrors.project_id}
							</div>
						)}
					</Form.Group>
				)}

				{taskCategories && Object.keys(taskCategories).length > 0 && (
					<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
						<Form.Label>Task Name</Form.Label>
						<Form.Control as="select" required value={task_id} onChange={(e) => onTaskChange(e.target.value)}>
							<option value="">Select Task</option>

							{taskCategories && Object.entries(taskCategories).map(([groupName, tasks]) => (
								<optgroup key={groupName} label={groupName}>
									{tasks.map((task) => (
										<option key={task.task_ids} value={task.task_ids}>
											{task.task_name}
										</option>
									))}
								</optgroup>
							))}
						</Form.Control >
						{validationErrors?.task_id && (
							<div className="text-danger">
								{validationErrors.task_id}
							</div>
						)}
					</Form.Group>
				)}

				<Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
					<Form.Label>Remarks</Form.Label>
					<Form.Control as="textarea" rows={3} required onChange={(e) => onRemarkChange(e.target.value)} />
				</Form.Group>
			</Form>
			{/* {modal_warn && (
				<div style={{ color: 'red' }}>
					project and remark missing.
				</div>
			)} */}
		</Modal.Body>
		<Modal.Footer id="mc-modal-header">
			<Button variant="secondary" onClick={onHide}>
				Cancel
			</Button>
			<Button variant="primary" onClick={onSubmit}>
				Submit
			</Button>
		</Modal.Footer>
	</Modal>
);

const validationSchema = Yup.object().shape({});

const mapStateToProps = (state) => {
	return {
		user: state.user,
		dashboard: state.dashboard,
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		biometrixLogMulti: (post_data, id) => dispatch(biometrixLogMulti(post_data, id)),
		fetchProjectTaskData: () => dispatch(fetchProjectTaskData()),
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(MultiQuickpunch);
